export default __webpack_public_path__ + "static/media/ArmButtonActive.7c0f3aab.svg";